import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import SVG from 'react-inlinesvg';
import { useTheme } from '@mui/material/styles';
import { Points } from '../../../points';
import { useLoyaltyPageContext } from '../../context';

type Props = {
  icon: string,
  title: React.ReactNode,
  points?: { gems: number, exp: number },
  mainFontColor: string,
}

const EarnPointsCard: React.FC<Props> = ({
  icon,
  title,
  points,
  mainFontColor,
}) => {
  const theme = useTheme();
  const { tierConfig } = useLoyaltyPageContext();
  return (
    <Box
      height="100%"
      sx={{
        border: '1px solid #CFCFCF',
        borderRadius: '10px',
        bgcolor: 'white',
      }}
      p={2}
    >
      <Grid
        height="100%"
        container
        alignContent="center"
        spacing={2}
        wrap="nowrap"
      >
        <Grid>
          <Box sx={{
            width: '5rem',
            height: '5rem',
            bgcolor: 'background.paper',
            borderRadius: '6px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '& svg': {
              width: '2.4rem',
              height: '2.4rem',
              '& circle': {
                fill: theme.palette.primary.main,
              },
              '& path:not([stroke="none"])': {
                stroke: theme.palette.primary.main,
              },
              '& path[fill="black"], & path[fill="#DA604F"]': {
                fill: theme.palette.primary.main,
              },
              '& #Grupo_179866': {
                '& path': {
                  stroke: 'none',
                  fill: theme.palette.primary.main,
                },
              },
              '& #Rectángulo_40428': {
                stroke: 'none',
                fill: theme.palette.primary.main,
              },
            },
          }}
          >
            <SVG src={icon}>
              <img src={icon} alt="" />
            </SVG>
          </Box>
        </Grid>
        <Grid container direction="column" wrap="nowrap">
          <Grid>
            <Typography
              variant="subtitle1"
              fontSize={{
                xs: 14,
                sm: 16,
              }}
              fontWeight={400}
              lineHeight="24px"
            >
              {title}
            </Typography>
          </Grid>
          {
            points && (
              <Grid>
                <Box
                  sx={{
                    '> div > div': {
                      fontSize: {
                        xs: 14,
                        sm: 16,
                      },
                      lineHeight: '24px',
                    },
                  }}
                >
                  <Points points={points} textColor={mainFontColor} tierConfig={tierConfig} />
                </Box>
              </Grid>
            )
          }
        </Grid>
      </Grid>
    </Box>
  );
};

export default EarnPointsCard;
